import type { Datumbereik } from './typen.js';

const AMSTERDAM = new Intl.DateTimeFormat('en-CA', {
  timeZone: 'Europe/Amsterdam',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
});

// Datum, optioneel tijd (T of spatie), optioneel zone. Zonder zone = wandkloktijd, in elke tijdzone gelijk (CAP-9).
const PATROON = /^(\d{4}-\d{2}-\d{2})(?:[T ](\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?)(Z|[+-]\d{2}:?\d{2})?)?$/;

function ontleed(iso: string) {
  const m = PATROON.exec(iso.trim());
  if (!m) return null;
  const [, dag, tijd, zone] = m as unknown as [string, string, string | undefined, string | undefined];
  const d = new Date(`${dag}T00:00:00Z`);
  if (Number.isNaN(d.getTime()) || d.toISOString().slice(0, 10) !== dag) return null;
  return { dag, tijd, zone };
}

/** Kalenderdag (`YYYY-MM-DD`) in Europe/Amsterdam; een kale datum of een tijd zonder zone telt als die dag. `null` bij onzin. */
export function kalenderdag(iso: string): string | null {
  const o = ontleed(iso);
  if (!o) return null;
  if (!o.tijd || !o.zone) return o.dag;
  const d = new Date(`${o.dag}T${o.tijd}${o.zone}`);
  if (Number.isNaN(d.getTime())) return null;
  const deel = (type: string) => AMSTERDAM.formatToParts(d).find((p) => p.type === type)?.value;
  return `${deel('year')}-${deel('month')}-${deel('day')}`;
}

/** Sorteersleutel in ms; een tijd zonder zone wordt als UTC gelezen, zodat server en browser gelijk sorteren. */
export function tijdstip(iso: string): number | null {
  const o = ontleed(iso);
  if (!o) return null;
  const t = Date.parse(`${o.dag}T${o.tijd ?? '00:00'}${o.zone ?? 'Z'}`);
  return Number.isNaN(t) ? null : t;
}

/** "Vanaf" na "tot en met": melden en niet filteren. */
export function datumOmgedraaid(bereik: Datumbereik): boolean {
  const van = bereik.van ? kalenderdag(bereik.van) : null;
  const tot = bereik.tot ? kalenderdag(bereik.tot) : null;
  return van !== null && tot !== null && van > tot;
}
